import { FC, useState } from 'react';
import { Box, Image } from '@chakra-ui/react';

import boxImg from 'assets/brand/box.png';
import { formatAmount } from 'common/formatAmount';
import IconButton from 'components/_core/IconButton';
import Text from 'components/_core/Text';

import { NavigationHighlightBlock } from '../NavigationHighlightBlock';
import locales from './locales';

interface ReferralBoxProps {
  remainingReferrerAmount: number | null;
}

const ReferralBox: FC<ReferralBoxProps> = ({ remainingReferrerAmount }) => {
  const [hasClosedReferralBox, setHasClosedReferralBox] = useState(
    localStorage.getItem('hasClosedReferralBox') === 'true',
  );

  if (hasClosedReferralBox) {
    return null;
  }

  return (
    <NavigationHighlightBlock to="/referral">
      <Image alt="" boxSize="32px" role="presentation" src={boxImg} />
      <Text flexGrow={1} size="sm" variant="primary">
        {locales.formatString(locales.text, {
          amount: formatAmount({
            forcePlusSign: false,
            value: remainingReferrerAmount ?? 250,
            withNoMinorUnitDigits: true,
          }),
        })}
      </Text>
      <Box alignSelf="flex-start" position="absolute" right={0} top={8}>
        <IconButton
          aria-label={locales.close}
          color="grey.600"
          icon="nav-close"
          onClick={(e) => {
            e?.preventDefault();
            localStorage.setItem('hasClosedReferralBox', 'true');
            setHasClosedReferralBox(true);
          }}
          variant="inline-secondary"
        />
      </Box>
    </NavigationHighlightBlock>
  );
};

export default ReferralBox;
